/**
 * Resolve a YouTube watch/share URL to an embed-safe iframe src.
 * Returns null when the URL is missing or not a recognized YouTube link.
 */
export function resolveYouTubeEmbedUrl(videoUrl) {
  if (!videoUrl || typeof videoUrl !== 'string') {
    return null;
  }

  const trimmed = videoUrl.trim();
  if (!trimmed) {
    return null;
  }

  let videoId = null;

  try {
    const parsed = new URL(trimmed);
    const host = parsed.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      videoId = parsed.pathname.replace(/^\//, '').split('/')[0];
    } else if (host === 'youtube.com' || host === 'm.youtube.com') {
      if (parsed.pathname === '/watch') {
        videoId = parsed.searchParams.get('v');
      } else if (parsed.pathname.startsWith('/embed/')) {
        videoId = parsed.pathname.replace('/embed/', '').split('/')[0];
      } else if (parsed.pathname.startsWith('/shorts/')) {
        videoId = parsed.pathname.replace('/shorts/', '').split('/')[0];
      }
    }
  } catch {
    return null;
  }

  if (!videoId || !/^[a-zA-Z0-9_-]{11}$/.test(videoId)) {
    return null;
  }

  return `https://www.youtube.com/embed/${videoId}`;
}

export function resolveHelpVideoUrl(env = import.meta.env) {
  const fromEnv = env.VITE_HELP_VIDEO_URL;
  if (fromEnv && typeof fromEnv === 'string' && fromEnv.trim()) {
    return fromEnv.trim();
  }
  return null;
}
